export default __webpack_public_path__ + "media/images/41-c035bcbdbf76cfaba0c651c440d78f6b.jpg";